import { render, staticRenderFns } from "./CopySelectedTrade.vue?vue&type=template&id=b6a6db14&scoped=true&"
import script from "./CopySelectedTrade.vue?vue&type=script&lang=js&"
export * from "./CopySelectedTrade.vue?vue&type=script&lang=js&"
import style0 from "./CopySelectedTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CopySelectedTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./CopySelectedTrade.vue?vue&type=style&index=2&id=b6a6db14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a6db14",
  null
  
)

export default component.exports